import { useQuery } from "react-query";
import { useIvideon } from "./useIvideon";
import { useState } from "react";

export const useGetAvailabilityReport = () => {
  const [params, setParams] = useState<string>();
  const { getAvailabilityReport } = useIvideon();

  const getKeys = (params: string) => {
    setParams(params);
  };
  const { data, isLoading, isError } = useQuery({
    queryKey: ["useGetAvailabilityReport", params],
    queryFn: () => getAvailabilityReport(params),
    enabled: !!params,
    cacheTime: 0,
  });

  return { data: data?.data?.fileHash, isLoading, isError, getKeys };
};
